import { facetTypeDetails } from './types/facetTypeDetails';
import SearchType from './types/SearchType';

const AdvancedSearchUtility = {
  sortFiltersByFacetType: (filters) => filters.reduce((buckets, filter) => {
    const { facetId } = filter;
    if (!buckets[facetId]) {
      buckets[facetId] = [];
    }
    buckets[facetId].push(filter);
    return buckets;
  }, {}),
  //
  sortFiltersByOperatorType: (filters) => filters.reduce((buckets, filter) => {
    const { operatorId } = filter;
    if (!buckets[operatorId]) {
      buckets[operatorId] = [];
    }
    buckets[operatorId].push(filter);
    return buckets;
  }, {}),
  //
  getFilterSelectOptions: (searchTypeId, disabledOptions = []) => Object.keys(facetTypeDetails)
    .filter(
      (optionKey) => facetTypeDetails[optionKey].validSearchTypes.includes(searchTypeId),
    )
    .map((optionKey) => {
      const { id, displayValue } = facetTypeDetails[optionKey];

      const isChannelTypeLocked = id === 4 && searchTypeId === SearchType.CHANNEL;
      const isDisabled = disabledOptions.includes(id);

      return {
        value: id,
        label: displayValue,
        isDisabled,
        isFixed: isChannelTypeLocked,
      };
    }),
  //
  getSelectedOptionsByValue: (options, facets, optionValue = 'facetId') => options
    .filter((option) => facets.some((facet) => facet[optionValue] === option.value)),
  //
  filterSelectedOptions: (options, selected) => {
    const selectedValues = selected.map((option) => option.value);
    return options.filter((option) => !selectedValues.includes(option.value));
  },
};

export default AdvancedSearchUtility;
